import React from "react"
import { CabPorQueIntramet } from "./style"
const cabPorQueIntramet = () => {
  return (
    <CabPorQueIntramet>
      <div className="card">
        <div className="cabCol1">
          <h4 className="cabCol1-title">
            ¿POR QUÉ ELEGIR A <span>INTRAMET?</span>
          </h4> 
        </div>
        {/* <div className="cabCol2">
          <p className="cabCol2-text">
            Somos la fábrica de carrocerias lider en el Sur del Perú
          </p>
        </div> */}
      </div>
    </CabPorQueIntramet>
  )
}
export default cabPorQueIntramet
